import { isRejectedConnectionOperation } from "@/lib/data/requests/connections/connection";

type Command = () => Promise<unknown>;
const pendingPlans = new Map<string, Command[]>();

// A retry continues the original plan even when onSettled refreshed the owner.
export async function runConnectionPlan(id: string, build: () => Command[]) {
  const commands = pendingPlans.get(id) ?? build();
  pendingPlans.set(id, commands);
  try {
    while (commands.length) {
      await commands[0]();
      commands.shift();
    }
    pendingPlans.delete(id);
  } catch (error) {
    if (isRejectedConnectionOperation(error)) pendingPlans.delete(id);
    throw error;
  }
}
